<template>
  <b-modal id="optionsModal"
    size=lg
    body-bg-variant="dark"
    hide-backdrop
    content-class="shadow"
    :title=current_item.name
    @hidden="emitCloseOptionsModal"
  >
    <div role="tablist">
      <b-card v-for="(option, index) in optionsMenu" :key="option.id" no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button v-if="option.add_price > 0" block v-b-toggle="'accordion-' + option.id" variant="dark">{{option.name}} - {{option.add_price | toCurrency}}</b-button>
          <b-button v-else block v-b-toggle="'accordion-' + option.id" variant="dark">{{option.name}}</b-button>
          <b-alert v-if="invalidMultiSelect && optState[index]==false" show variant="primary">You have selected too many options!</b-alert>
        </b-card-header>
        <b-collapse :id="'accordion-' + option.id" visible accordion="option-accordion" role="tabpanel">
          <b-card-body label="Make your selection">
            <b-form-textarea v-if="option.select_qty=='Notes'" id="line-notes" rows="2" v-model="linedets.new_line_notes" placeholder="Notes, allergies, etc"></b-form-textarea>
            <b-form-input v-else-if="option.select_qty=='Price'" id="overridden-price" type="number" v-model="linedets.new_overridden_item_price" step="0.01" placeholder="Overridden item price"></b-form-input>
            <b-form-group v-else-if="option.select_qty==1">
              <b-form-radio-group
                v-model="option_select[index]"
                :options="option.optionitems"
                value-field="id"
                text-field="name_price"
                stacked
              ></b-form-radio-group>
            </b-form-group>
            <b-form-group v-else>
              <b-form-checkbox-group
                v-model="option_select[index]"
                :options="option.optionitems"
                value-field="id"
                text-field="name_price"
                switches
                stacked
                :state="optState[index]"
                @input="limitMultiSelect(index, option.select_qty)"
              ></b-form-checkbox-group>
            </b-form-group>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <template v-if="!edititem" v-slot:modal-footer="{ cancel, ok }">
      <b-button variant="outline-dark" @click="cancel()">Back</b-button>
      <b-button id="addOptions" variant="dark" @click="ok(); emitAddOrderLineToDB(current_item);">Add</b-button>
    </template>
    <template v-else v-slot:modal-footer="{ cancel, ok }">
      <b-button variant="outline-dark" @click="cancel()">Back</b-button>
      <b-button id="updateOptions" variant="dark" @click="ok(); emitRemoveOldItem(); emitAddOrderLineToDB(current_item)">Update</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'Options',
  props: ['current_item', 'option_select', 'edititem', 'line_notes', 'overridden_item_price'],
  data () {
    return {
      optState: [],
      linedets: {
        new_line_notes: '',
        new_overridden_item_price: ''
      },
    }
  },

  computed: {
    invalidMultiSelect: function() {
      if (this.option_select) {
        return this.optState.includes(false) ? true : false;
      } else {
        return false;
      }
    },

    optionsMenu: function() {
      var optionarr = [];
      // build a line notes obj with an id that won't interfere and a sort_order which will always be last
      const linenotesobj = {
        'id': 9999999,
        'name': 'Notes / Allergies, etc.',
        'select_qty': 'Notes',
        'name_price': 'Notes',
        'sort_order': 999
      }
      // build a custom price obj with an id and sort order just above the line notes
      const priceoverrideobj = {
        'id': 9999998,
        'name': 'Override Item Price',
        'select_qty': 'Price',
        'name_price': 'Price',
        'sort_order': 998
      }
      optionarr = optionarr.concat(this.current_item.options);
      if (this.current_item.allow_price_override) {
        optionarr.push(priceoverrideobj)
      }
      optionarr.push(linenotesobj);
      return optionarr;
    },

  },

  methods: {
    updateLineNotesWithOverriddenPrice() {
      const oipText = '***'+this.$options.filters.toCurrency(this.linedets.new_overridden_item_price)+'***/'
      // locate the end of the overridden price note
      const posNotes = this.linedets.new_line_notes.indexOf("***/")
      // create a string for the "actual note" if there is one
      const actualNotes = posNotes>=0 ? this.linedets.new_line_notes.slice(posNotes+5) : this.linedets.new_line_notes
      // if actualNotes are empty - add Overridden price, else append notes to price
      this.linedets.new_line_notes = actualNotes=='' ? oipText : oipText + ' ' + actualNotes
    },

    emitCloseOptionsModal() {
      this.$emit('emit-close-options-modal');
    },

    // adjusttype = 'remove' - Remove one from the quantity, remove item if qty = 1
    emitRemoveOldItem() {
      this.$emit('emit-remove-old-item');
    },

    limitMultiSelect(i, max_select) {
      // get element of button to enable / disable
      const btn = (this.edititem) ? document.getElementById("updateOptions") : document.getElementById("addOptions");
      // If number of selected items reaches the maximum allowed for that option "header"
      if (this.option_select[i].length <= max_select || max_select==0) {
        this.optState[i] = null;
        btn.disabled = false;
      } else {
        this.optState[i] = false;
        btn.disabled = true;
      }
    },

    emitAddOrderLineToDB(item) {
      if (this.linedets.new_overridden_item_price>0) {
        this.updateLineNotesWithOverriddenPrice()
      }
      this.$emit('emit-add-order-to-db', item, this.linedets);
    },

    async showOptionsOrAddItem() {
      if (this.current_item.options.length==0 && this.edititem==false && this.current_item.allow_price_override == false) {
        await this.emitAddOrderLineToDB(this.current_item);
        this.emitCloseOptionsModal();
      } else {
        this.$bvModal.show('optionsModal');
      }
    }

  },

  mounted() {
    this.linedets.new_line_notes = this.line_notes;
    this.linedets.new_overridden_item_price = this.overridden_item_price;
    this.showOptionsOrAddItem();
  }
}
</script>
<style>
  #optionsModal___BV_modal_outer_ {
    z-index: 1240 !important;
  }

  @media (min-width: 1200px) {
    #optionsModal {
      padding-right: 320px;
    }
  }

</style>
